var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleBatteryCritical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81641 5.73438H9.1875C9.20077 5.73438 9.21612 5.73932 9.22852 5.75195C9.24124 5.76492 9.25 5.78518 9.25 5.80762V8.02832H14.75V5.80762C14.75 5.78517 14.7588 5.76492 14.7715 5.75195C14.7839 5.73932 14.7992 5.73438 14.8125 5.73438H18.1875C18.1942 5.73434 18.2013 5.7355 18.208 5.73828C18.2148 5.74109 18.2214 5.74577 18.2275 5.75195C18.2338 5.75829 18.2392 5.76676 18.2432 5.77637C18.2471 5.78597 18.25 5.79667 18.25 5.80762V8.02832H19.875C19.9557 8.02834 20.0362 8.04544 20.1113 8.07715C20.1863 8.10889 20.2551 8.15534 20.3135 8.21484C20.3719 8.27445 20.419 8.34567 20.4512 8.4248C20.4833 8.50401 20.5 8.5895 20.5 8.67578V17.8516C20.5 17.9378 20.4833 18.0234 20.4512 18.1025C20.419 18.1817 20.3719 18.2529 20.3135 18.3125C20.2551 18.3721 20.1863 18.4194 20.1113 18.4512C20.0362 18.4829 19.9557 18.499 19.875 18.499H4.125C3.96241 18.499 3.8045 18.4328 3.68652 18.3125C3.56833 18.1919 3.5 18.0262 3.5 17.8516V8.67578L3.5127 8.54688C3.53745 8.42101 3.59783 8.30527 3.68652 8.21484C3.8045 8.09456 3.96241 8.02836 4.125 8.02832H5.75391V5.80762C5.75391 5.78518 5.76267 5.76492 5.77539 5.75195C5.78777 5.7394 5.80317 5.73438 5.81641 5.73438Z",
    stroke: "#ff0700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17773 12.3828H9.88362",
    stroke: "#ff0700",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5879 12.3828H17.2938",
    stroke: "#ff0700",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4414 14.2344V10.5285",
    stroke: "#ff0700",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleBatteryCritical);
export default __webpack_public_path__ + "static/media/ic_tele_battery_critical.75e78cbd443d5807948c842fce30fd0b.svg";
export { ForwardRef as ReactComponent };